import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import SimpleLogin from './SimpleLogin';
import Dashboard from './Dashboard';

const MainApp: React.FC = () => {
  const { user, login, logout } = useAuth();

  const handleLoginSuccess = async (username: string, password: string) => {
    const success = await login({ username, password });
    return success;
  };

  if (user) {
    return <Dashboard onLogout={logout} />;
  }

  return <SimpleLogin onLoginSuccess={handleLoginSuccess} />;
};

export default MainApp;